import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FmsUnitModel } from 'Modules'
import { typeInitiatorRequest } from 'Constants/Address.constants'

type FmsState = {
	fmsUnits: FmsUnitModel[]
}

export const fmsInitialState: FmsState = {
	fmsUnits: [],
}

export namespace FmsNS {
	export type GetAll = PayloadAction<{ params: { origin: typeInitiatorRequest; query: string } }>
	export type SetAll = PayloadAction<FmsUnitModel[]>
	export type ClearAll = PayloadAction
}

export const fmsSlice = createSlice({
	name: 'fms',
	initialState: fmsInitialState,
	reducers: {
		getAll: (state, action: FmsNS.GetAll) => {},
		setAll: (state, action: FmsNS.SetAll) => {
			state.fmsUnits = action.payload
		},
		clearAll: (state, action: FmsNS.ClearAll) => {
			state.fmsUnits = []
		},
	},
})
